module.exports = __webpack_public_path__ + "static/media/SINGLE-BREASTED 1 BUTTON.01a881cd.svg";